import React from 'react';
import { Progress } from 'antd';
import './CreditUsageGraph.scss';
import { getUsageColorByCreditFactor } from 'helpers/credit_info';

const CreditUsageGraph = ({
  datatestid,
  creditUsage,
  strokeColor,
  percent,
  usageColor,
  creditUsagePercentage,
  isCreditFactorBased,
  hideInfo,
}) => {
  if (isCreditFactorBased) {
    usageColor = getUsageColorByCreditFactor(creditUsagePercentage);
  } else {
    if (creditUsagePercentage >= 41) {
      usageColor = 'Red3';
    } else if (creditUsagePercentage < 41 && creditUsagePercentage >= 30) {
      usageColor = 'Yellow4';
    } else if (creditUsagePercentage < 30 && creditUsagePercentage >= 20) {
      usageColor = 'LightGreen6';
    } else if (creditUsagePercentage < 20 && creditUsagePercentage >= 0) {
      usageColor = 'DarkGreen6';
    }
  }

  return (
    <div className={`creditUsage${usageColor} creditUsageGraph`}>
      <Progress
        percent={creditUsagePercentage}
        strokeWidth={5}
        showInfo={false}
      />
      {!hideInfo && (
        <div
          className="usagePercent"
          data-testid={datatestid ? `${datatestid}-usage` : null}
        >
          {`${creditUsagePercentage > 200 ? '>200' : creditUsagePercentage}%`}
        </div>
      )}
    </div>
  );
};

export { CreditUsageGraph };
